/**
 * 统一错误日志出口。
 *
 * 业务代码不再直接调用 console，全部走这里，理由有两条：
 * 1. 规则集把散落的 console 调用判为【严重】；收成单一出口后，
 *    只在这一处保留经过说明的例外，其余业务代码保持干净。
 * 2. 将来要接错误上报（Sentry / 自建埋点）只改这一个函数，
 *    不必再去翻散落在各组件里的 console.error。
 *
 * 注意：这里不做「生产环境静默」——线上问题的排查线索比控制台整洁更重要，
 * 需要静默时应在上报层做采样，而不是把错误直接吞掉。
 */

/**
 * 记录一条错误日志。
 * @param {string} scope 出错的业务场景，如「加载模板详情失败」
 * @param {unknown} error 捕获到的原始错误对象
 */
export const logError = (scope, error) => {
  // eslint-disable-next-line no-console -- 全项目唯一的 console 出口，见文件头说明
  console.error(`[${scope}]`, error)
}

/**
 * 记录一条信息日志（非错误）。
 * @param {string} scope 业务场景，如「appUpdate」
 * @param {...unknown} args 要输出的内容
 */
export const logInfo = (scope, ...args) => {
  // eslint-disable-next-line no-console -- 全项目唯一的 console 出口，见文件头说明
  console.info(`[${scope}]`, ...args)
}
